import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Header, {
  NavLink,
  NavLinks,
  PrimaryLink,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from "../headers/light.js";

const Hero = () => {
  const navLinks = [
    <NavLinks key={2}>
      <NavLink href="/sessions">Sessions</NavLink>
      <NavLink href="/juniors">Junior Section</NavLink>
      <NavLink href="/contact_us">Contact Us</NavLink>
      <NavLink href="/championships">Club Championships</NavLink>
      <NavLink href="/login">Sign In</NavLink>
      {/* <NavLink href="/shop">
            Club Kit
          </NavLink> */}
      <PrimaryLink href="/join">JOIN US</PrimaryLink>
    </NavLinks>,
  ];

  const StyledHeader = styled(Header)`
    ${tw`tw-pt-8 tw-max-w-none`}
    ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
      ${tw`tw-text-gray-100 hover:tw-border-gray-300 hover:tw-text-gray-300`}
    }
    ${NavToggle}.closed {
      ${tw`tw-text-gray-100 hover:tw-text-primary-500`}
    }
  `;

  const rootStyle = {
    width: "100vw",
    height: "100vh",
    position: "relative",
    overflow: "hidden",
    marginLeft: "-2rem",
    marginRight: "-2rem",
    marginTop: "-2rem",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    maxHeight: "100vh",
    backgroundColor: "rgba(50, 0, 0, 0.4)",
  };
  const TwoColumn = tw.div`tw-px-4 tw-flex tw-justify-between tw-items-center tw-flex-col lg:tw-flex-row tw-h-5/6`;
  const LeftColumn = tw.div`tw-flex tw-flex-col tw-items-center lg:tw-block tw-mt-auto sm:tw-mb-auto tw-mb-[25%]`;
  const Heading = styled.h1`
    ${tw`tw-text-4xl  lg:tw-text-left sm:tw-text-5xl lg:tw-text-6xl xl:tw-text-6xl tw-font-black tw-text-gray-100 tw-leading-none`}
    span {
      ${tw`tw-inline-block tw-mt-2`}
    }
  `;
  const HeroContainer = tw.div`tw-z-20 tw-relative tw-px-4 sm:tw-px-8 tw-max-w-screen-xl tw-mx-auto tw-max-h-screen tw-h-full`;
  const HighlightedTextTop = tw.span`tw-bg-gray-900 tw-text-gray-100 tw-px-4 tw-pt-5 tw-pb-8 tw-transform -tw-skew-x-12 tw-inline-block tw-rotate-[2deg] tw-rounded-br-lg tw-rounded-tl-lg tw-text-3xl sm:tw-text-4xl md:tw-text-6xl`;
  const HighlightedTextBottom = tw.span`tw-bg-primary-500 tw-text-gray-100 tw-pl-10 sm:tw-pl-20 tw-pr-4 tw-py-2 tw-transform -tw-skew-x-12 tw-inline-block tw-rotate-[-2deg] tw-translate-y-[-25px] tw-rounded-tr-lg tw-rounded-bl-lg tw-text-3xl sm:tw-text-4xl md:tw-text-6xl`;

  return (
    <section style={rootStyle}>
      <video
        style={{ minHeight: "100%", minWidth: "100%", objectFit: "cover" }}
        src="./hero-video-v1.mp4"
        type="video/mp4"
        autoPlay
        muted
        loop
        playsInline
      ></video>
      <div style={overlayStyle}>
        <HeroContainer>
          <StyledHeader links={navLinks} />
          <TwoColumn>
            <LeftColumn>
              <Heading>
                <HighlightedTextTop>Bristol & District</HighlightedTextTop>
                <br />
                <HighlightedTextBottom>Triathletes</HighlightedTextBottom>
              </Heading>
            </LeftColumn>
          </TwoColumn>
        </HeroContainer>
      </div>
    </section>
  );
};

export default Hero;
